const links = document.querySelectorAll('.no-link')
let el;
links.forEach(link => {
	if (link.classList.contains('no-link-first')) {
		el = document.createElement('h6')
		el.classList.add('no-link-first')
	} else {
		el = document.createElement('h6')
	}

	el.textContent = link.textContent
	link.parentNode.replaceChild(el, link)
})